import React from "react";

export default function WrapperBlueStyle({ children, noSpace }: any) {
  return (
    <div className={`${noSpace ? "-mb-96" : ""} cardContainerPath py-64 pb-104 md:pb-128 bg-primary-100`}>
      {children}
    </div>
  );
}
